(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-sizes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card-sizes')) {
    customElements.define(
      'product-card-sizes',
      class extends HTMLElement {
        connectedCallback() {
          this.fit = this.fit.bind(this);
          this.observer = new ResizeObserver(this.fit);
          this.observer.observe(this);
          document.fonts?.ready.then(this.fit);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        fit() {
          const items = [...this.querySelectorAll('.product-card-sizes__item')];
          const more = this.querySelector('.product-card-sizes__more');
          const width = this.clientWidth;
          if (!items.length || !more || !width) return;

          items.forEach((item) => (item.hidden = false));
          more.hidden = true;

          const left = this.getBoundingClientRect().left;
          const rights = items.map((item) => item.getBoundingClientRect().right - left);
          if (rights[rights.length - 1] <= width + 0.5) return;

          more.hidden = false;
          more.textContent = `+${items.length}`;
          const gap = parseFloat(getComputedStyle(this).columnGap) || 0;
          const moreWidth = more.getBoundingClientRect().width + gap;

          let visible = 1;
          for (let count = items.length - 1; count >= 1; count--) {
            if (rights[count - 1] + moreWidth <= width + 0.5) {
              visible = count;
              break;
            }
          }

          items.forEach((item, index) => (item.hidden = index >= visible));
          more.textContent = `+${items.length - visible}`;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
